var _rect, _path, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTg(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 37,
    height: 36,
    viewBox: "0 0 37 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.891113,
    y: 0.5,
    width: 35,
    height: 35,
    rx: 17.5,
    stroke: "url(#paint0_linear_702_1795)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.071 22.8745L17.275 19.7926L22.8705 14.7507C23.1182 14.5249 22.8195 14.4156 22.4917 14.6123L15.5847 18.9765L12.5975 18.0294C11.9563 17.8472 11.9491 17.4028 12.7432 17.0822L24.3787 12.5941C24.9106 12.3537 25.4206 12.7253 25.2166 13.5413L23.2348 22.8745C23.0964 23.5375 22.6957 23.6978 22.1419 23.3918L19.1256 21.1623L17.6757 22.5685C17.5082 22.736 17.3697 22.8745 17.071 22.8745Z",
    fill: "#E6DAFE"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_702_1795",
    x1: 0.391113,
    y1: 18,
    x2: 36.3911,
    y2: 18,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#332F46"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.475,
    stopColor: "#E6DAFE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#353148"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTg);
export default __webpack_public_path__ + "static/media/tg.cf0a5fdfc1a58fb79fce269c57889f7b.svg";
export { ForwardRef as ReactComponent };